// extracted by mini-css-extract-plugin
export var boxItems = "_9y-1";
export var boxItemsLg = "_9y-2";
export var button = "_9y-7";
export var buttonHoverless = "_9y-9";
export var buttonLg = "_9y-8";
export var filterGroupBox = "_9y-0";
export var icon = "_9y-3";
export var iconSecondary = "_9y-6";
export var iconWrapper = "_9y-4";
export var iconWrapperLg = "_9y-5";
export var truncatedLabel = "_9y-a";